import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function RentIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M23 1V3H3V23H1V1H23ZM21 7H23V16H5V7H7V4.48242H9V7H19V4.48242H21V7ZM21 9H7V14H21V9Z",
    fill: "currentColor"
  }));
}